import React from "react";
import "../css/footer.css";
import "bootstrap/dist/css/bootstrap.min.css";

import logoFD from "../images/LOGO FD FINAL.png";
import logoSanp from "../images/SanPancracio.png";

const Footer = () => {
  return (
    <footer id="footer">
      <div className="container">
        <div className="row align-items-center py-3">
          {/* Izquierda: logo FD */}
          <div className="col-4 d-flex justify-content-start">
            <img src={logoFD} alt="FD" className="logo-fd" />
          </div>

          {/* Centro: San Pancracio centrado */}
          <div className="col-4 d-flex justify-content-center">
            <div className="app-footer">
              <img src={logoSanp} alt="San Pancracio" className="footer-logo" />
            </div>
          </div>

          {/* Derecha: versión / by */}
          <div id="contacto" className="col-4 text-end">
            <p className="mb-0 small text-muted"><strong>Versión 1.0</strong></p>
            <p className="mb-0 small text-muted"><strong>by F.D.</strong></p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
